const BROWSER_SMALL_SCREEN = 480;
let _browserIsMobile = "none";

function browserGetBrowserWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}

function browserGetBrowserHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

// Cookies ---------------------------------------------------------------------

function browserSetCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function browserGetCookie(cname) {
  const name = cname + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// rendering

function browserAfterRendering(action) {
  requestAnimationFrame(() => {
    setTimeout(() => {
      action();
    });
  });
}

// images ----------------------------------------------------------------------

function browserImageIsReady(image, options = {}) {
  const resolveOnError = options.resolveOnError === true;
  const resolveOnTimeout = options.resolveOnTimeout === true;
  const timeoutMs =
    typeof options.timeoutMs === "number" && options.timeoutMs > 0
      ? options.timeoutMs
      : 0;

  return new Promise((resolve, reject) => {
    if (!image) {
      reject(new Error("Image element is missing."));
      return;
    }

    if (image.complete) {
      if (image.naturalWidth > 0 && image.naturalHeight > 0) {
        resolve();
      } else if (resolveOnError) {
        resolve();
      } else {
        reject(new Error(`Failed to load image's URL: ${image.src || image}`));
      }
      return;
    }

    let settled = false;
    const settleResolve = () => {
      if (settled) return;
      settled = true;
      if (timer !== null) {
        clearTimeout(timer);
      }
      resolve();
    };
    const settleReject = (err) => {
      if (settled) return;
      settled = true;
      if (timer !== null) {
        clearTimeout(timer);
      }
      reject(err);
    };

    const onLoad = () => {
      if (image.naturalWidth > 0 && image.naturalHeight > 0) {
        settleResolve();
      } else if (resolveOnError) {
        settleResolve();
      } else {
        settleReject(
          new Error(`Failed to load image's URL: ${image.src || image}`)
        );
      }
    };
    const onError = () => {
      if (resolveOnError) {
        settleResolve();
      } else {
        settleReject(
          new Error(`Failed to load image's URL: ${image.src || image}`)
        );
      }
    };

    const timer =
      timeoutMs > 0
        ? setTimeout(() => {
            if (resolveOnTimeout) {
              settleResolve();
            } else {
              settleReject(
                new Error(
                  `Timed out loading image's URL: ${image.src || image}`
                )
              );
            }
          }, timeoutMs)
        : null;

    image.addEventListener("load", onLoad, { once: true });
    image.addEventListener("error", onError, { once: true });
  });
}

// menu ------------------------------------------------------------------------

function browserIsSmallScreen()
{
    if (browserGetBrowserWidth() < BROWSER_SMALL_SCREEN)
    {
        return true;
    }
    else
    {
        return (false);
    }
}

// mobile ----------------------------------------------------------------------
function browserIsMobile() {
  if (_browserIsMobile === "none") {
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      _browserIsMobile = true;
    } else {
      _browserIsMobile = false;
    }
  }
  return _browserIsMobile;
}

// sharing ---------------------------------------------------------------------
function browserCanShare() {
  return !!navigator.share;
}

function browserShare(urlString) {
  navigator
    .share({
      url: urlString
    })
    .then(() => console.log("Share was successful."))
    .catch((error) => console.log("Sharing failed", error));
}

// ------------------------------------------------------------------------------
function onBrowserTooltip(event) {
  if (browserGetBrowserWidth() < 480) {
    const target = event.target;
    const tooltipText = target.getElementsByClassName("posterTooltiptext");
    const marginLeft =
      -target.getBoundingClientRect().left +
      (browserGetBrowserWidth() - 280) / 2;
    tooltipText[0].style.marginLeft = marginLeft + "px";
  }
}

// -----------------------------------------------------------------------------

export {
  BROWSER_SMALL_SCREEN,
  browserGetBrowserWidth,
  browserGetBrowserHeight,
  browserSetCookie,
  browserGetCookie,
  browserAfterRendering,
  browserImageIsReady,
  browserIsSmallScreen,
  browserIsMobile,
  browserCanShare,
  browserShare,
  onBrowserTooltip
};
